// 1. Sesuaikan nama dengan yang ada di Modal dan HTML
const nama_pasangan = "Alfin & Ruri";

const tanggal_pernikahan = "April 11, 2026 12:30:00";

export { nama_pasangan, tanggal_pernikahan };
